import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { client } from "../../../client";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";

// DataGrid
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, InputBase } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UserFinancialModal from "./UserFinancialModal";

const GET_USER_LIST = gql`
  query getUserListByAdmin(
    $id: Int
    $name: String
    $email: String
    $phone_number: String
    $type: Type
    $region1: String
    $region2: String
    $page: Int
    $pageSize: Int
  ) {
    getUserListByAdmin(
      id: $id
      name: $name
      email: $email
      phone_number: $phone_number
      type: $type
      region1: $region1
      region2: $region2
      page: $page
      pageSize: $pageSize
    ) {
      id
      name
      email
      phone_number
      type
      region1
      region2
      ad_agreement
      current_point
      created_at
    }
  }
`;

const UserFinancialDetails = () => {
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const fetchData = async () => {
    await client
      .query({
        query: GET_USER_LIST,
        variables: {
          page: 1,
          pageSize: 10000,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        setUserList(res.data.getUserListByAdmin);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setModalOpen(!isModalOpen);
  };

  const handleCloseClick = () => {
    setModalOpen(false);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "name", headerName: "이름", flex: 1 },
    { field: "email", headerName: "이메일", flex: 1 },
    { field: "phone_number", headerName: "핸드폰번호", flex: 1 },
    { field: "type", headerName: "유형", flex: 1 },
    {
      field: "edit",
      headerName: "정보 조회",
      flex: 1,
      renderCell: (params) => (
        <Button
          onClick={() => {
            handleEditClick(params.row);
          }}
        >
          상세보기
        </Button>
      ),
    },
  ];

  const handleExportPointHistoryCSV = async () => {
    try {
      // API 호출 URL - 환경 변수 사용
      const baseUrl = process.env.REACT_APP_REST_API_URL;
      if (!baseUrl) {
        console.error("REACT_APP_API_URL is not defined in your .env file");
        alert("API URL이 설정되지 않았습니다. .env 파일을 확인해주세요.");
        return;
      }
      const apiUrl = `${baseUrl}/admin/point-history/csv`;

      // 필요한 경우 인증 토큰을 헤더에 추가합니다.
      const accessToken = localStorage.getItem("accessToken");
      const headers = {
        // 'Content-Type': 'application/json' 헤더를 제거하고,
        // 아래의 헤더를 추가하여 CSRF 검사를 통과시킵니다.
        "apollo-require-preflight": "true",
      };
      if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }

      const response = await fetch(apiUrl, { headers });

      if (!response.ok) {
        // API 에러 처리
        const errorData = await response.json();
        throw new Error(
          errorData.message || `CSV 다운로드 실패: ${response.statusText}`
        );
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);

      // Content-Disposition 헤더에서 파일 이름 추출 시도
      let filename = "point_history.csv"; // 기본 파일 이름
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"])(.*?)\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[3]) {
          filename = matches[3];
        }
      }
      link.setAttribute("download", filename);

      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // 메모리 해제
    } catch (error) {
      console.error("Error downloading point history CSV:", error);
      alert(`오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <div>
      <Box
        margin={"7px"}
        display={"flex"}
        height={"70px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box ml={"5px"}>
          <h2>유저 결제 정보</h2>
        </Box>
        <Box>
          <Button
            variant="contained"
            startIcon={<FileDownloadIcon />}
            onClick={handleExportPointHistoryCSV}
            sx={{ mr: "5px" }}
          >
            결제 내역 추출
          </Button>
        </Box>
      </Box>
      <Box sx={{ height: "calc(100vh - 200px)", width: "100%" }}>
        <DataGrid
          rows={userList}
          columns={columns}
          components={{
            Toolbar: GridToolbar,
          }}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 100 },
            },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </Box>

      <UserFinancialModal
        isOpen={isModalOpen}
        handleCloseClick={handleCloseClick}
        refetchParentData={fetchData}
        data={selectedUser}
      ></UserFinancialModal>
    </div>
  );
};

export default UserFinancialDetails;
